import React from 'react'
import { offer } from '../images/index'

const Offer = () => {
	return (
		<div
			className='offer flex items-center rounded-2xl px-4 py-7 justify-around'
			style={{
				background:
					'linear-gradient(257.93deg, rgba(46, 74, 255, 0.2) -2.99%, rgba(0, 0, 0, 0) 44.36%), linear-gradient(248.07deg, rgba(153, 37, 245, 0.077) 45.78%, rgba(235, 0, 255, 0.22) 84.06%)',
			}}
		>
			<div className='font-["Open_Sans"] font-semibold text-lg leading-6 px-5'>
				50% Discount for all purchase this morning
			</div>
			<img src={offer} alt='Offer image'></img>
		</div>
	)
}

export default Offer
